/*
 * SidePanelUploadSingleImage.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 10 2023 mys Company
 */

import { useEffect, useRef, useState } from 'react'
import imagePlaceHolder from '../../assets/images/imageplaceholder.png'
import { BASE_URL, getUserId } from '../../config/constant/constants'
import { localization } from '../../config/localize/localizable'
import { useFileHooks } from '../../modules/file/hooks/useFileHooks'
import * as mysUtilities from '../../utilities/mysUtilities'

const SidePanelUploadSingleImage = ({ title, imageId, sourceId, type, className, uploaded }) => {
    //
    //MARK: VARIABLE
    const fileRef = useRef()
    const imageRef = useRef()
    const service = useFileHooks()
    let [model, setModel] = useState({})

    //
    //MARK: METHODS

    // onChange File Service

    const handleChange = (e) => {
        let models = []
        let fileCount = e.target.files.length
        const formData = new FormData()

        if (fileCount === 1) {
            // a file was selected
            for (let i = 0; i < fileCount; i++) {
                formData.append('attachments', e.target.files[i], e.target.files[i].name)
                var reader = new FileReader()
                reader.readAsDataURL(e.target.files[0])

                var item = {}
                item.title = title
                item.description = e.target.files[i].name
                item.userId = getUserId()
                item.default = true
                item.priority = 1
                item.entityName = type
                item.sourceId = sourceId
                models.push(item)

                reader.onload = (event) => {
                    // called once readAsDataURL is completed
                    imageRef.current.src = event.target.result
                }
            }
            formData.append('jsonString', JSON.stringify(models))
            formData.append('reportProgress', 'true')
            formData.append('multiSize', 'true')
            saveImage(formData)

            fileRef.current.value = null
        }
    }

    // Save File Service

    const saveImage = (body) => {
        service.uploads(body, {
            onSuccess: (response) => {
                if (response.data.result) {
                    if (uploaded) uploaded(response.data.result.id)
                } else {
                    fileRef.current.value = null
                }
            },
        })
    }

    // Delete File Service

    const handleDelete = () => {
        service.uploads(model?.id, {
            onSuccess: (response) => {
                if (response.data.result) {
                    setModel({ ...model, id: response.data.result.id })
                    if (uploaded) uploaded(response.data.result.id)
                } else {
                    fileRef.current.value = null
                }
            },
        })
    }

    useEffect(() => {
        if (imageId) {
            model = { ...model, id: imageId }
            service.getOne(model?.id, {
                onSuccess: async (response) => {
                    setModel(response.data.result)
                },
            })
        }
    }, [imageId])

    return (
        <>
            <div className={`w-full bg-white p-2 shadow rounded-md ${className}`}>
                <div className="text-sm font-bold mb-1"> {localization.primaryimage}</div>
                <hr />
                <div className="p-2">
                    <input type="file" className="hidden" ref={fileRef} onChange={handleChange} accept="image/*" multiple={false} />
                    <div className="w-full rounded shadow ">
                        <span className={`w-5 h-5 absolute left-7 bg-red-500  text-white rounded-full text-center select-none ${model?.id ? '' : 'hidden'}`} onClick={handleDelete}>
                            x
                        </span>
                        <img
                            src={!mysUtilities.isNullOrEmpty(model.id) ? (model ? BASE_URL + 'v1/files/' + (model?.id ?? 0) + '/m' : imagePlaceHolder) : ''}
                            className="w-full h-full rounded"
                            ref={imageRef}
                            alt=""
                            onClick={(e) => fileRef.current.click()}
                            onError={(e) => {
                                e.target.src = imagePlaceHolder
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SidePanelUploadSingleImage
